import { trackEvent, type TrackedEvent } from '../../shared/api/rpc';

/**
 * Случайный идентификатор браузера для аналитики продаж: без персональных данных.
 * localStorage может быть недоступен (приватный режим) — тогда id живёт до перезагрузки.
 */
let memoryId: string | null = null;

function randomId(): string {
  const bytes = new Uint8Array(12);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function sessionId(): string {
  try {
    const existing = localStorage.getItem('shinka:sid');
    if (existing && /^[a-f0-9]{24}$/.test(existing)) return existing;
    const id = randomId();
    localStorage.setItem('shinka:sid', id);
    return id;
  } catch {
    memoryId ??= randomId();
    return memoryId;
  }
}

const sentOnce = new Set<string>();

/** Событие для sales:report. `once` — не чаще раза за загрузку страницы. */
export function track(slug: string, event: TrackedEvent, opts: { once?: boolean } = {}): void {
  const key = `${slug}:${event}`;
  if (opts.once && sentOnce.has(key)) return;
  sentOnce.add(key);
  void trackEvent(slug, event, sessionId());
}
